export default __webpack_public_path__ + "static/media/DDD-Knowledge-Portal.67833198.png";